module.exports = __webpack_public_path__ + "img/40_69_001_780.bcafcef4.jpg";